// keep in sync with angular
const LoginResults = {
  SUCCESS: 'SUCCESS',
  NEED_APPROVAL: 'NEED_APPROVAL',
  WRONG_DOMAIN: 'WRONG_DOMAIN',
  FAILED: 'FAILED'
};

module.exports = { LoginResults };
